/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import {
  BaseQueryModel,
  IQueryModelOpts,
  useQuery,
  useGqlClient,
} from '@r-client/shared/data/client';
import {
  IFundedOfferingsQuery,
  IFundedOfferingsQueryVariables,
  FundedOfferingsDocument,
} from './types';
import { IOfferingConnection } from '@r-client/data/graphql-types';
export type { IOfferingConnection };

//export interface IFundedOfferingsQueryOpts extends Omit<IQueryModelOpts<IFundedOfferingsQueryVariables>, 'variables'> {
export interface IFundedOfferingsQueryOpts
  extends IQueryModelOpts<IFundedOfferingsQueryVariables> {
  variables: IFundedOfferingsQueryVariables;
}

export class FundedOfferingsQuery extends BaseQueryModel<
  IFundedOfferingsQuery,
  IFundedOfferingsQueryVariables
> {
  // This is fine. Here we explicitly change interface for query
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(opts: IFundedOfferingsQueryOpts) {
    super(opts);
  }

  get query() {
    return FundedOfferingsDocument;
  }
}
export function useFundedOfferingsQuery(
  opts: Omit<IFundedOfferingsQueryOpts, 'client'>
) {
  const client = useGqlClient();
  return useQuery(
    () => new FundedOfferingsQuery({ ...opts, client }),
    opts?.variables
  );
}
